import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { IMAGE_SRC, STATUS_OPTIONS } from '../../../shared-constants';
import { TwoColumnFormData } from '../two-column-form.constants';

@Component({
  selector: 'app-column-form',
  templateUrl: './column-form.component.html',
  styleUrls: ['./column-form.component.scss'],
  standalone: false,
})
export class ColumnFormComponent implements OnInit, OnChanges {
  @Input({ required: true }) header!: string;
  @Input({ required: true }) buttonText!: string;
  @Input({ required: true }) data!: TwoColumnFormData[];
  @Input({ required: true }) disable!: boolean;
  @Input() iconName = '';
  @Input() searchPlaceholder = '';

  @Input() isGroupForm!: boolean;

  @Output() emitCheckboxesSelected = new EventEmitter<boolean>();
  @Output() emitAssignUnassign = new EventEmitter<TwoColumnFormData[]>();

  readonly SELECT_TEXT = STATUS_OPTIONS.ALL_SELECTED;
  readonly IMAGES = IMAGE_SRC;

  displayedData!: TwoColumnFormData[];
  searchValue!: string;
  allSelected = false;
  isButtonDisabled = true;

  ngOnInit(): void {
    this.displayedData = this.data;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.data?.firstChange && changes.data?.currentValue) {
      this.displayedData = changes.data.currentValue;
      this.allSelected = false;
      this.isButtonDisabled = true;
    }
  }

  onAllSelect(): void {
    this.data?.forEach((value) => (value.selected = this.allSelected));
    const numberItemsSelected = this.selectedValues?.length;
    this.isButtonDisabled = numberItemsSelected === 0;
    this.emitCheckboxesSelected.emit(this.isButtonDisabled);
  }

  search(searchData: string): void {
    const searchValue = searchData;
    if (searchValue === '') {
      this.displayedData = this.data;
      return;
    }

    const filteredValues = this.data.filter((value: TwoColumnFormData) => {
      return value.data.code
        ?.toString()
        .toLowerCase()
        .includes(searchValue?.toString().toLowerCase() ?? '');
    });
    this.displayedData = [...filteredValues];
  }

  clearSearch() {
    this.searchValue = '';
    this.displayedData = this.data;
  }

  onAssignUnassignClick(): void {
    this.emitAssignUnassign.emit(this.selectedValues);
    this.data.forEach((value) => {
      value.selected = false;
    });
    this.allSelected = false;
  }

  onCheckboxChanges() {
    const numberItemsSelected = this.selectedValues.length;
    this.allSelected = numberItemsSelected === this.data.length;
    this.isButtonDisabled = numberItemsSelected === 0;
    this.emitCheckboxesSelected.emit(this.isButtonDisabled);
  }

  get selectedValues() {
    return this.data?.filter((value) => !!value.selected);
  }

  get showAltSearch() {
    return this.searchValue?.length > 0;
  }
}
